import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { currentVacationHrs } from '../../../redux/vacationHours/vacationHourActions';

import VacationHourTable from './components/VacationHourTable';

const columns = [
  { id: 'empId', label: 'Employee Id', align: 'center' },
  { id: 'empName', label: 'Name', align: 'center' },
  { id: 'vacationHrs', label: 'Vacation Hours', align: 'center' },
  { id: 'sickHrs', label: 'Sick Hours', align: 'center' },
  { id: 'holidayHrs', label: 'Holiday Hours', align: 'center' },
];

const VocationHrsList = props => {
  document.title = 'Sciata Vacation Hours';
  const vacationHour = useSelector(state => state.vacationHour.currentVacationHrs || []);

  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const [orderAscending, setOrderAscending] = useState(true);
  const [asc, setAsc] = useState('desc');
  const [searchTerm, setSearchTerm] = useState('');
  const [activeRecords, setActiveRecords] = useState(true);

  useEffect(() => {
    dispatch(currentVacationHrs());
  }, []);

  useEffect(() => {
    setRows(vacationHour || []);
  }, [vacationHour]);

  const sortArray = (arr = [], property = '') => () => {
    let array = [...arr];
    setOrderAscending(!orderAscending);
    orderAscending ? setAsc('asc') : setAsc('desc');
    if (typeof property === 'string') {
      setRows(
        array.sort((a, b) => {
          let nameA = a.empLName.toUpperCase();
          let nameB = b.empLName.toUpperCase();

          if (orderAscending) {
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          }
          if (!orderAscending) {
            if (nameB < nameA) return -1;
            if (nameB > nameA) return 1;
            return 0;
          }
        })
      );
    }
    property && orderAscending
      ? setRows(array.sort((a, b) => a[property] - b[property]))
      : setRows(array.sort((a, b) => b[property] - a[property]));

    property && !orderAscending
      ? setRows(array.sort((a, b) => b[property] - a[property]))
      : setRows(array.sort((a, b) => a[property] - b[property]));
    return array;
  };

  const userTableProps = {
    columns,
    rows,
    sortArray,
    orderAscending,
    asc,
    activeRecords,
    searchTerm,
    ...props,
  };
  return (
    <>
      <h1>Holiday / Vacation / Sick Hours</h1>
      <VacationHourTable
        {...userTableProps}
        showUploadButton={true}
        gotoUpload={() => {
          props.history.push('/admin/uploadVacationHrs');
        }}
      />
    </>
  );
};

export default withRouter(VocationHrsList);
